import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import { RoleGroupColumns } from "../../../data/DynamicTable/Collumns";
import { allRoleGroups } from "../../../data/Axios/queries";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { roleManagemenUrl, loanManagementUrl } from "../../../config";
import { fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import RoleGroupForm from "./Forms";
import Filter from "./Filter";
import ReportCards from "./ReportCards.js";
import CrbMonthlyReportCard from "./CrbMonthlyReportCard";

const base_url = roleManagemenUrl.uri;

const CRB_MONTHLY_REPORT_COMPANY_IDS = [27, 29];

const ReportBrowser = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);
  const roleGroupId = parseInt(decodedToken.RoleGroupId);
  //1 is admin 2 is company user 3 is region user 4 is Branch user 5 is fieldofficer
  const isCrbCompanyIdEligible = CRB_MONTHLY_REPORT_COMPANY_IDS.includes(companyId);

  // ── CRB report access, gated per role group ──────────────────────────────
  // Mirrors the asset finance / device access pattern used elsewhere. The
  // loanSettings table carries one boolean per access level:
  //   CRBRegionAccess, CRBBranchAccess, CRBFieldOfficerAccess
  // Note: there's no CRBCompanyAccess setting provided, so Admin (1) and
  // Company (2) users are not gated by this and fall back to the existing
  // company-id check only.
  const [crbAccessSettings, setCrbAccessSettings] = useState({});

  useEffect(() => {
    async function fetchCrbAccessSettings() {
      try {
        const response = await fetchJsonDynamic(
          "loanSettings",
          null,
          null,
          loanManagementUrl.uri
        );
        if (response?.results) {
          const settings = JSON.parse(response.results);

          const crbAccessSettingNames = [
            "CRBRegionAccess",
            "CRBBranchAccess",
            "CRBFieldOfficerAccess",
          ];
          const accessMap = {};
          crbAccessSettingNames.forEach((settingName) => {
            const found = settings.find((s) => s.Setting === settingName);
            accessMap[settingName] = found?.Value?.toLowerCase() === "true";
          });
          setCrbAccessSettings(accessMap);
        }
      } catch (error) {
        console.error("Error fetching CRB access settings:", error);
        setCrbAccessSettings({});
      }
    }
    fetchCrbAccessSettings();
  }, []);

  // ── Map the logged-in user's RoleGroupId to the loanSettings key that
  // controls whether they're allowed to see the CRB report section.
  // Admin (1) and Company (2) have no dedicated access setting, so they
  // are left ungated here (null) and rely solely on the company-id check.
  const roleGroupCrbAccessSettingName = {
    1: null,
    2: null,
    3: "CRBRegionAccess",
    4: "CRBBranchAccess",
    5: "CRBFieldOfficerAccess",
  }[roleGroupId];

  const isCrbRoleEligible = roleGroupCrbAccessSettingName
    ? !!crbAccessSettings[roleGroupCrbAccessSettingName]
    : true;

  const showCrbMonthlyReport = isCrbCompanyIdEligible && isCrbRoleEligible;

  const actions = {
    entity: "Role Group",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };

  return (
    <Box m="10px">
      <Filter />
      {showCrbMonthlyReport && <CrbMonthlyReportCard />}
      <ReportCards />
    </Box>
  );
};

export default ReportBrowser;